import { EventEmitter, Injectable } from '@angular/core';
import { AllowedDealer, CurrentUser, UserDealer } from '../models/user/user';
import { Comissioned } from '@models/comissioned';
import { LOCAL_STORAGE_KEY_ACCESS_POINT } from '../const/localStorageKeys';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public readonly accessPointChangeEvent = new EventEmitter()

  init() {
    throw new Error('Method not implemented.');
  }

  public permissions: string[]
  public user: CurrentUser;
  private _allowedDealers: AllowedDealer[];
  private accessPoint: Comissioned;

  constructor() { }

  public getPermissions(): string[] {
    return this.permissions || [];
  }

  public setPermissions(permissions: string[]): void {
    this.permissions = permissions
  }

  public getUser(): CurrentUser {
    return this.user
  }

  public getEconomicGroupAndDealers(): AllowedDealer[] {
    return this._allowedDealers;
  }

  public getAcessPoint(): Comissioned {
    return this.accessPoint;
  }

  public getAllAllowedDealers(): UserDealer[] {
    const dealersFromEconomicGroups = this.user.comissioners.filter(e => e.isEconomicGroup)
                                                          .flatMap(d => d.comissioners);

    const dealersFromNonEconomicGroups = this.user.comissioners.filter(e => !e.isEconomicGroup)
       .map<UserDealer>(e => ({
                                id: e.id,
                                description: e.description,
                                identifierCode: e.identifierCode
                              }));

    const result = [...dealersFromEconomicGroups, ...dealersFromNonEconomicGroups];

    return result
  }

  public getAllAllowedDealersForCurrentHierachy() {

    const loggedEconomicGroup = this.user.comissioners.filter(e => e.isEconomicGroup).find(e => e.identifierCode === this.accessPoint.identifierCode);
    if (loggedEconomicGroup) {
      return loggedEconomicGroup.comissioners;
    }

    return [this.accessPoint]
  }

  public setUser(user: CurrentUser): void {
    this.user = user
  }

  public setAllowedDealerAndEconomicGroups(allowedDealers: AllowedDealer[]): void {
    this._allowedDealers = allowedDealers;
  }

  public setAccessPoint(accessPoint: Comissioned): void {
    this.accessPoint = accessPoint;
    localStorage.setItem(LOCAL_STORAGE_KEY_ACCESS_POINT, JSON.stringify(accessPoint));
    this.accessPointChangeEvent.emit();
  }
}
